/**
 *
 * ListFilters
 *
 */
// import { FormattedMessage } from 'react-intl';
// import messages from './messages';

import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
// import styled from 'styled-components';
import { withStyles } from '@material-ui/core/styles'
import classNames from 'classnames'
import React from 'react'

import Icon from '../Icon'

const styles = theme => ({
  '.MuiGrid-item*': {
    paddingTop: '0px',
    paddingBottom: '0px',
  },
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  margin: {},
  stgInput: {
    color: `var(--gameday-inputField-inputTextColor, ${theme.inputField.inputTextColor})`,
    '& >input': {
      backgroundColor: `var(--gameday-inputField-inputBGColor, ${theme.inputField.inputBGColor})`,
    },
    '&:before': {
      borderBottom: `1px solid ${`var(--gameday-inputField-inputBorder, ${theme.inputField.inputBorder})`}`,
    },
    '&:hover': {
      '&::before': {
        borderBottom: '2px solid #9b9b9b !important',
      },
    },
    '&:after': {
      borderBottom: '2px solid #009ade',
    },
  },
  stgLabel: {
    margin: `0  0 ${theme.spacing(4)} 0`,
    position: 'unset',
  },
  mandatory: {
    color: theme.status.errorColor,
    lineHeight: 'unset',
  },
  errorP: {},
  locked: {
    pointerEvents: 'none',
    marginTop: '32px !important',
  },
  positionLeft: {
    position: 'absolute',
    right: 0,
    bottom: '4px',
  },
  positionRelative: {
    position: 'relative',
  },
})

/* eslint-disable react/prefer-stateless-function */
class InputWithLabel extends React.Component {
  render() {
    const {
      classes,
      ContainterStyle,
      label,
      value,
      isMandatory,
      onChange,
      isError,
      errorMessage,
      locked,
      doNotShowLockIcon,
      ...rest
    } = this.props

    // const { filterData, selected } = this.state;
    return (
      <FormControl
        className={classes.margin}
        error={isError}
        style={ContainterStyle}
        fullWidth
        // eslint-disable-next-line no-return-assign
        innerRef={node => (this.formControlNode = node)}
      >
        {label ? (
          <InputLabel shrink={false} htmlFor={label} className={classes.stgLabel}>
            {label}
            {isMandatory && <span className={classes.mandatory}> *</span>}
          </InputLabel>
        ) : null}
        <Input
          id={`input_${label}`}
          value={value}
          onChange={onChange}
          className={classNames(classes.stgInput, locked ? classes.locked : null)}
          readOnly={locked}
          {...rest}
        />
        {locked && !doNotShowLockIcon && (
          <div className={classes.positionRelative}>
            <Icon
              iconSize={15}
              iconName="lock"
              color="grey"
              className={classNames(classes.iconLeft, classes.positionLeft)}
            />
          </div>
        )}
        <FormHelperText className={classes.errorP} id={`${label}-error-text`}>
          {isError && errorMessage}
        </FormHelperText>
      </FormControl>
    )
  }
}

InputWithLabel.defaultProps = {
  isMandatory: false,
  isError: false,
  errorMessage: 'Invalid value',
  locked: false,
}
export default withStyles(styles)(InputWithLabel)
